import { render, staticRenderFns } from "./render_checkbox_group.vue?vue&type=template&id=70a55b92&scoped=true&"
import script from "./render_checkbox_group.vue?vue&type=script&lang=js&"
export * from "./render_checkbox_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a55b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a55b92')) {
      api.createRecord('70a55b92', component.options)
    } else {
      api.reload('70a55b92', component.options)
    }
    module.hot.accept("./render_checkbox_group.vue?vue&type=template&id=70a55b92&scoped=true&", function () {
      api.rerender('70a55b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_checkbox_group.vue"
export default component.exports